// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"6e1a99a3","733":"6400c1cd","777":"58d910b8"}[chunkId] + ".chunk.js";
};